import * as React from 'react'
import styled from 'styled-components'
import I18n from '../../../../core/i18n'
import { IJsonResponse } from '../../../../core/JsonApiSerializer'
import { adminService } from '../../../../core/services'
import * as interfaces from '../../../../static/interfaces'
import * as Hooks from '../../../../utils/hooks'
import { Button, Buttons } from '../../../atoms'
import AdminLayoutIndex from '../_layouts'
import * as constants from '../../../../static/constants'

declare var window: interfaces.IWindow

interface IProps {
  pages: {
    pages: IJsonResponse
  }
}

const AdminPageIndex: React.FC<IProps> = props => {
  Hooks.SetDocumentTitle('Admin pages')
  const { data } = adminService.getDataFromJson(props.pages.pages)
  const [pages, setPages] = React.useState(data)

  const handleDelete = React.useCallback(async id => {
    const { flush } = await adminService.deletePage(id)
    window.flashMessages.addMessage({ text: flush.message, type: flush.type })
    setPages(prev => prev.filter(page => page.id !== id))
  }, [])

  const handleClickDelete = id => {
    if (window.confirm(I18n.t('generic.delete_confirmation'))) {
      handleDelete(id)
    }
  }

  return (
    <AdminLayoutIndex
      model="pages"
      title={
        <Heading>
          <span>Pages</span>
          <Button small={true}>
            <a href="/admin/pages/new">{I18n.t('generic.create_new')}</a>
          </Button>
        </Heading>
      }
      main={
        <Table>
          <div className="Table_Row">
            <div className="Table_Header">{I18n.t('generic.id')}</div>
            <div className="Table_Header path">Path</div>
            <div className="Table_Header created">{I18n.t('generic.created_at')}</div>
            <div className="Table_Header updated">{I18n.t('generic.updated_at')}</div>
            <div className="Table_Header action" />
          </div>
          {pages.map(page => {
            return (
              <div className="Table_Row" key={`page-${page.id}`}>
                <div className="Table_Data">{page.id}</div>
                <div className="Table_Data path">{page.path}</div>
                <div className="Table_Data updated">{page.created_at}</div>
                <div className="Table_Data updated">{page.updated_at}</div>
                <div className="Table_Data action">
                  <Buttons inline={true}>
                    <a href={`/admin/pages/${page.id}/edit`}>
                      <Button small={true}>{I18n.t('generic.edit')}</Button>
                    </a>
                    <Button
                      textColor={constants.COLORS.danger}
                      borderColor={constants.COLORS.danger}
                      small={true}
                      handleClick={() => {
                        handleClickDelete(page.id)
                      }}
                    >
                      {I18n.t('generic.delete')}
                    </Button>
                    <a href={`/page/${page.path}`} target="_blank" className="Preview_Link">
                      <Button
                        small={true}
                        backgroundColor={constants.COLORS.primary}
                        textColor={constants.COLORS.white}
                      >
                        {I18n.t('generic.preview')}
                      </Button>
                    </a>
                  </Buttons>
                </div>
              </div>
            )
          })}
        </Table>
      }
    />
  )
}

const Heading = styled.div`
  .Button {
    margin-left: 12px;
  }
`

const Table = styled.div`
  .Table_Row {
    display: table;
    width: 100%;
  }

  .Table_Header,
  .Table_Data {
    display: table-cell;
    padding: 8px;
    border-bottom: solid 1px ${constants.COLORS.divider};
    vertical-align: middle;
  }

  .path {
    width: 320px;
  }

  .updated {
    width: 220px;
  }

  .action {
    width: 220px;
  }
`

export default AdminPageIndex
